export default "__VITE_ASSET___F38_Iwk__"